import { useState, useEffect } from 'react';
import { debounce } from 'throttle-debounce';

export function useWindowResize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = debounce(500, () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    });

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
